import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import gql from 'graphql-tag';
import { ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { cliente_proveedor } from 'src/app/shared/object/cliente_proveedor.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ValidadoresService } from 'src/app/shared/validadores/validadores';
import { FormDatosFinancierosComponent } from '../form-datos-financieros/form-datos-financieros.component';
import { ClientesService } from 'src/app/services/clientes.service';
import { TipoMensaje } from 'src/Wheel.Styles.HighVolume/Mensaje';
import { MANTENEDOR_CLIENTES_MODULO, OP_EDICION_DATOS_FINANCIEROS } from '../cliente-mantenedor.constants';

@Component({
  selector: 'app-mantenedor-clientes-modal-datos-financieros',
  templateUrl: './modal-datos-financieros.component.html',
  styleUrls: ['../clientes.component.scss'],
  providers: [SecurityService, ValidadoresService],
})
export class MantenedorClientesModalDatosFinancierosComponent implements OnInit {

  // Outputs
  @Output() onSuccess: EventEmitter<void> = new EventEmitter<void>()

  @Input() optionsTipoCobro: Array<any> = [];
  @Input() optionsCondicionPago: Array<any> = [];
  @Input() optionsListaPrecios: Array<any> = [];

  private client: GraphQLClient = null;

  // Modales
  @ViewChild('datosFinancieros', { static: true }) datosFinancierosModal: ModalDirective;
  @ViewChild(FormDatosFinancierosComponent, { static: true }) formDatosFinancieros: FormDatosFinancierosComponent

  // Data & Tmp
  public rutEmpresa: number;
  public sucursalEmpresa: number;
  public codigoModulo: number;
  public rutUsuario: number

  public clienteSeleccionado: cliente_proveedor | any;

  public puedeEditarSeccion = false;

  // Utils
  private log: any

  constructor(
    client: GraphQLClient,
    private clientesService: ClientesService,
    private accesolocalstorage: SecurityService,
    private clog: ConsoleService,
    public validadores: ValidadoresService,
    public rutService: RutService,
    public toastService: ToastService,
    private messageRendererService: MessageRendererService
  ) {
    this.log = this.clog.log('MANTENEDOR-CLIENTES/DATOS FINANCIEROS')
    this.client = client;
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo());
    this.codigoModulo = 1;
    this.rutUsuario = Number(this.accesolocalstorage.getRutUsuario());
  }

  loadAndShow(cliente: cliente_proveedor) {
    this.clienteSeleccionado = cliente;
    this.clienteSeleccionado.rutFormato = this.rutService.AgregarDV(cliente.rut);
    this.formDatosFinancieros.loadAndShow(cliente, () => {
      this.datosFinancierosModal.show();
      this.aplicarPermisoEdicionFinancieros();
    });
  }

  private aplicarPermisoEdicionFinancieros() {
    const self = this;
    this.clientesService.rolOperacionPermitida(
      {
        rut_usu: self.rutUsuario,
        codgo_modulo: MANTENEDOR_CLIENTES_MODULO,
        cod_operacion: OP_EDICION_DATOS_FINANCIEROS,
      },
      ({ mensajes }) => {
        self.puedeEditarSeccion =
          mensajes && mensajes.length > 0 && mensajes[0].tipo === TipoMensaje.SUCCESS;
        self.formDatosFinancieros.setModoSoloLectura(!self.puedeEditarSeccion);
      }
    );
  }

  guardarDatosFinancieros() {
    const self = this;
    this.clientesService.rolOperacionPermitida(
      {
        rut_usu: self.rutUsuario,
        codgo_modulo: MANTENEDOR_CLIENTES_MODULO,
        cod_operacion: OP_EDICION_DATOS_FINANCIEROS,
      },
      ({ mensajes }) => {
        if (!mensajes || mensajes.length === 0 || mensajes[0].tipo !== TipoMensaje.SUCCESS) {
          self.messageRendererService.showErrors(mensajes);
          return;
        }
        self.ejecutarGuardarFinancieros();
      }
    );
  }

  private ejecutarGuardarFinancieros() {
    const valid = this.formDatosFinancieros.validate();
    if (!valid) {
      this.toastService.error('Complete datos financieros');
      return;
    }
    const self = this;

    const formData = this.formDatosFinancieros.getFormData();

    const clienteProveedor: any = {
      rut: this.clienteSeleccionado.rut, // Number(this.formDatosFinancieros.get('rutCliente').value),
      empresa_rut: Number(self.rutEmpresa),
      //  tipo_cobro_codigo: Number(formData.tipoCobro),
      tipo_cobro_codigo: Number(0),//Campo deprecado
      lista_precio_codigo: Number(formData.listaPrecios),
      limite_credito: Number(formData.limiteCredito),
      descuento_maximo: Number(formData.descuentoMaximo),
      afecto_reglas_comerciales: Boolean(formData.clieneAfectoReglasComerciales),
      // nombre: formData.nombreFantasia,
      rut_usuario_actualiza: self.rutUsuario,
      codigoModulo : self.codigoModulo,
      // tipo_cliente_codigo: Number(this.formDatosFinancieros.get('tipo_cliente_codigo').value),
      moduloGrabacion: 4
    };

    const direccionObj: any = {
      cliente_proveedor_rut: this.clienteSeleccionado.rut, //Number(this.formDatosFinancieros.get('rutCliente').value),
      codigo: this.clienteSeleccionado.codigo_direccion,
      empresa_rut: Number(self.rutEmpresa),
      condicion_pago_codigo: Number(formData.condicionPago),
      moduloGrabacion: 2,
      rut_usuario: self.rutUsuario,
      codigoModulo : self.codigoModulo,
    }

    self.log('clienteProveedor', clienteProveedor)
    self.log('direccionObj', direccionObj)

    const bodyx = clienteProveedor;
    this.client.mutate(
      {
        mutation: gql`
          mutation($entidad: cliente_proveedorInputType, $entidadDireccion: direccionInputType) {

            cliente_proveedor {
              guardar(entidad: $entidad) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  rut
                  nombre
                }
              }
            }

            direccion {
              guardar(entidad: $entidadDireccion) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
              }
            }

          }
        `,
        variables: {
          entidad: clienteProveedor,
          entidadDireccion: direccionObj
        },
      },
      function (respuesta) {
        if (respuesta.data.cliente_proveedor.guardar.respuesta != null) {
          // alert('Registro grabado');
          self.toastService.success('Registro grabado');
          self.onSuccess.emit()
          self.datosFinancierosModal.hide();
        } else {
          // alert(respuesta.data.cliente_proveedor.guardar.mensajes[0].texto);
          self.messageRendererService.showErrors(respuesta.data.cliente_proveedor.guardar.mensajes)
        }
        // setTimeout(() => self.filtraGrillaVistaPrincipal(), 1000);
      }
    );

    // this.client.mutate(
    //   {
    //     mutation: gql`
    //       mutation($entidadDireccion: direccionInputType) {

    //         direccion {
    //           guardar(entidad: $entidadDireccion) {
    //             mensajes {
    //               codigo
    //               contexto
    //               texto
    //               tipo
    //             }
    //           }
    //         }

    //       }
    //     `,
    //     variables: {
    //       entidadDireccion: direccionObj
    //     },
    //   },
    //   function (respuesta) {
    //     // if (respuesta.data.cliente_proveedor.guardar.respuesta != null) {
    //     //   alert('Registro grabado');
    //     //   self.editarModalDtoFinancieros.hide();
    //     // } else {
    //     //   alert(respuesta.data.cliente_proveedor.guardar.mensajes[0].texto);
    //     // }
    //     // setTimeout(() => self.filtraGrillaVistaPrincipal(), 1000);
    //     console.log('ok')
    //   }
    // );
  }

}
